import {
    IconBackend, IconDot, IconFrontend, IconInfra, IconMobile, IconPanel,
} from '../../../common/icons';

// Qué dibuja y de qué color va cada tipo de repositorio.
//
// The five values come from REPOSITORY_KINDS in the backend model — `backend`,
// `frontend`, `admin`, `mobile`, `infra` — and this is the only place that maps
// them to a shape and a tone. A component that picked its own icon would be a
// second table to keep in agreement with this one.
//
// `tone` is a CSS class suffix and not a colour: the colour lives in
// design/tokens.css as `--mm-kind-*`, with a value per theme. It could not be
// one value, and that is worth knowing before somebody tries to simplify it —
// the avatar tones of paleta.md §5 work as a PAIR, a pale fill plus dark ink,
// and without the fill the ink is unreadable on the dark surface. See §7.
//
// The colour never carries the meaning on its own: the chip always shows its
// word next to the glyph, and the five shapes differ by silhouette.
const KINDS = {
    backend:  { label: 'Backend',         Icon: IconBackend,  tone: 'backend' },
    frontend: { label: 'Frontend',        Icon: IconFrontend, tone: 'frontend' },
    admin:    { label: 'Panel',           Icon: IconPanel,    tone: 'panel' },
    mobile:   { label: 'Móvil',           Icon: IconMobile,   tone: 'mobile' },
    infra:    { label: 'Infraestructura', Icon: IconInfra,    tone: 'infra' },
};

// A kind this panel does not know still renders: its own value as the word, a
// neutral dot as the shape, and the grey tone. The day the backend adds a sixth
// it shows up as itself rather than as a blank cell.
export function kindOf(kind) {
    const known = KINDS[kind];
    if (known) return known;
    return { label: kind || 'Sin tipo', Icon: IconDot, tone: 'other' };
}

export const KIND_LIST = Object.entries(KINDS)
    .map(([value, meta]) => ({ value, ...meta }));
